/* ADVELLO lightbox next/previous.

   Kept separate from theme.js so the theme's own zoom code is untouched. This
   only adds two buttons, swipe, and swaps which image the existing lightbox
   shows.

   How it hooks in: every gallery slide renders a .product-zoom-trigger carrying
   data-zoom-src and data-zoom-alt, in gallery order. Clicking one is what opens
   the lightbox, so noting which one was clicked gives us the starting index.
   Moving next or previous then writes that trigger's src and alt into the
   lightbox image the theme already created.

   After each move we click the theme's own Reset control, so any zoom or pan the
   customer applied is cleared before the new image appears. Reusing their button
   avoids duplicating the transform logic - and avoids the two drifting apart.
*/
(function () {
  function setup(root) {
    var lightbox = root.querySelector('[data-product-lightbox]');
    var image = root.querySelector('[data-product-zoom-image]');
    var shell = root.querySelector('.product-lightbox-shell');
    var reset = root.querySelector('[data-product-zoom-reset]');
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-product-zoom-open]'));

    if (!lightbox || !image || !shell || triggers.length < 2) return;

    var index = 0;

    triggers.forEach(function (trigger, position) {
      trigger.addEventListener('click', function () { index = position; });
    });

    function build(direction, label, glyph) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'adv-lightbox-nav adv-lightbox-nav--' + direction;
      button.setAttribute('aria-label', label);
      button.innerHTML = '<span aria-hidden="true">' + glyph + '</span>';
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        move(direction === 'prev' ? -1 : 1);
      });
      shell.appendChild(button);
      return button;
    }

    function move(step) {
      index = (index + step + triggers.length) % triggers.length;
      var trigger = triggers[index];
      if (!trigger) return;
      if (reset) reset.click();
      image.src = trigger.getAttribute('data-zoom-src') || '';
      image.alt = trigger.getAttribute('data-zoom-alt') || '';
      if (counter) counter.textContent = (index + 1) + ' / ' + triggers.length;
    }

    build('prev', 'Previous image', '\u2039');
    build('next', 'Next image', '\u203a');

    var counter = document.createElement('p');
    counter.className = 'adv-lightbox-counter';
    counter.textContent = (index + 1) + ' / ' + triggers.length;
    shell.appendChild(counter);

    document.addEventListener('keydown', function (event) {
      if (lightbox.hasAttribute('hidden')) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });

    /* SWIPE.

       On a phone the arrow buttons are a poor second to the gesture people
       already expect, so a horizontal drag anywhere on the image moves it.

       Zoom is detected by reading the image's own transform, NOT by looking at
       whether the Reset button is visible. An earlier version did the latter and
       swipe never fired once, because that button sits in the DOM the whole time
       - so every gesture looked like a pan and was ignored.

       Still deliberately ignored:
       - more than one finger, because that is the theme's pinch-zoom;
       - any drag while actually zoomed in, because then dragging means panning
         around the photo.

       Thresholds: 45px of travel, and horizontal has to beat vertical by 1.6x,
       so a scroll or a wobbly tap never counts as a swipe. */
    var startX = 0;
    var startY = 0;
    var tracking = false;

    function zoomed() {
      var t = window.getComputedStyle(image).transform;
      if (!t || t === 'none') return false;
      var parts = t.match(/matrix\(([^)]+)\)/);
      if (!parts) return false;
      var scale = parseFloat(parts[1].split(',')[0]);
      return !isNaN(scale) && scale > 1.05;
    }

    function onStart(event) {
      if (lightbox.hasAttribute('hidden')) { tracking = false; return; }
      if (!event.touches || event.touches.length !== 1 || zoomed()) { tracking = false; return; }
      tracking = true;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }
    function onMove(event) {
      if (!tracking) return;
      if (event.touches && event.touches.length !== 1) tracking = false;
    }
    function onEnd(event) {
      if (!tracking) return;
      tracking = false;
      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < 45) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.6) return;
      move(dx < 0 ? 1 : -1);
    }

    /* Bound on the image as well as the shell: the theme's zoom layer sits over
       the picture and can swallow events aimed at the shell alone. */
    [shell, image].forEach(function (el) {
      el.addEventListener('touchstart', onStart, { passive: true });
      el.addEventListener('touchmove', onMove, { passive: true });
      el.addEventListener('touchend', onEnd, { passive: true });
      el.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    });

    // Keep the counter honest when the lightbox is opened from a thumbnail.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (!lightbox.hasAttribute('hidden') && counter) {
          counter.textContent = (index + 1) + ' / ' + triggers.length;
        }
      }).observe(lightbox, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-adv-product]')).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
